var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert(".ugc-rating[data-v-13]{margin-bottom:10px}.ugc-rating .rate-prompt[data-v-13]{margin:-6px 0 0}")
;(function(){var apiUrlPath;

apiUrlPath = '/api/ugc/rating';

module.exports = {
  mixins: [require('../../../shared/frontend/vue/vue-mixins')],
  props: {
    id: String,
    apiBaseUrl: String,
    csrfToken: String,
    loggedIn: Boolean,
    hasCCookie: Boolean
  },
  data: function() {
    return {
      aggregateRating: null,
      rating: null,
      minRating: 1,
      maxRating: 5,
      ratingCount: 0,
      reviewCount: 0,
      readOnly: false,
      apiUrl: apiUrlPath
    };
  },
  created: function() {
    this.apiUrl = this.apiBaseUrl + apiUrlPath;
    return $.getJSON(this.apiUrl + "?id=" + this.id).done((function(_this) {
      return function(res) {
        var data, ref, ref1, ref2;
        if (res.result === 'ok') {
          data = res.data || {};
          if (data.recommendation != null) {
            _this.aggregateRating = data.recommendation.rating;
            _this.rating = _this.aggregateRating;
            _this.minRating = (ref = data.ratingSystem) != null ? ref.minRating : void 0;
            _this.maxRating = (ref1 = data.ratingSystem) != null ? ref1.maxRating : void 0;
            _this.ratingCount = data.recommendation.total;
            return _this.reviewCount = (ref2 = data.reviewSummary) != null ? ref2.reviewsCount : void 0;
          }
        }
      };
    })(this));
  },
  methods: {
    updateRating: function() {
      return $.post(this.apiUrl, {
        id: this.id,
        rating: this.rating,
        _csrf: this.csrfToken
      }).done((function(_this) {
        return function(res) {
          if (res.result === 'ok') {
            return _this.readOnly = true;
          } else {
            _this.rating = _this.aggregateRating;
            return Modules.Shared.Helpers.JsonResponseHandler.loginRequired(res);
          }
        };
      })(this)).fail((function(_this) {
        return function() {
          return _this.rating = _this.aggregateRating;
        };
      })(this));
    }
  },
  components: {
    StarRating: require('vue-star-rating'),
    IframeLoginModal: require('../../../shared/frontend/components/iframe-login-modal.vue')
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function(){with(this){return _c('div',{staticClass:"ugc-rating",attrs:{"data-bhw":"UGCRating"}},[_c('star-rating',{attrs:{"max-rating":maxRating,"read-only":readOnly,"star-size":25,"padding":5,"show-rating":false,"increment":1},on:{"rating-selected":updateRating},model:{value:(rating),callback:function ($$v) {rating=$$v},expression:"rating"}}),_v(" "),_c('p',{staticClass:"rate-prompt"},[_v(_s(t('js.modules.ugc.ratings.rate_prompt')))]),_v(" "),(ratingCount || reviewCount)?_c('div',{attrs:{"itemprop":"aggregateRating","itemtype":"http://schema.org/AggregateRating","itemscope":""}},[(ratingCount)?[_c('span',{attrs:{"itemprop":"ratingCount"}},[_v(_s(ratingCount))]),_v(" "),_c('span',[_v(_s(t('js.modules.ugc.ratings.ratings')))])]:_e(),_v(" "),(reviewCount)?_c('meta',{attrs:{"itemprop":"reviewCount","content":reviewCount}}):_e(),_v(" "),_c('meta',{attrs:{"itemprop":"ratingValue","content":aggregateRating}}),_v(" "),_c('meta',{attrs:{"itemprop":"worstRating","content":minRating}}),_v(" "),_c('meta',{attrs:{"itemprop":"bestRating","content":maxRating}})],2):_e(),_v(" "),_c('iframe-login-modal',{attrs:{"logged-in":loggedIn,"has-c-cookie":hasCCookie}})],1)}}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-13"
